export default __webpack_public_path__ + "static/media/BDO-BNB.95f5852d.svg";